const state = {
	userData: localStorage.userData ? JSON.parse(localStorage.userData) : {},
	// casualForm: {}
}
const getters = {}
const mutations = {
	saveUserData(state, data) {
		state.userData = data
		localStorage.setItem('tokens', data.token)
		// localStorage.setItem('userData', JSON.stringify(data))
		// localStorage.setItem('userType', data.userType)
		
		// state.userData = { ...JSON.parse(localStorage.userData) }
	},
	resetUserType(state, val) {
		state.userType = val
	},
	saveCasualForm(state, data) {
		state.casualForm = data
	}
}
const actions = {
	saveUserData({ commit }, data) {
		commit('saveUserData', data)
	},
	// resetUserType({ commit }, val) {
	// 	commit('resetUserType', val)
	// },
	// saveCasualForm({ commit }, data) {
	// 	commit('saveCasualForm', data)
	// }
}
export default {
	state,
	getters,
	mutations,
	actions
}
